import DatePicker from "react-datepicker";
import { fr } from "date-fns/locale";
import { isBefore, startOfDay } from "date-fns";
import axios from "axios";
import { CalendarDays, X } from "lucide-react";

export default function ProfileScheduleModal({
  activeSession,
  selectedDate,
  setSelectedDate,
  onClose,
  onSaved,
  toast,
  API,
}) {
  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      if (activeSession.rescheduleMode) {
        await axios.post(
          `${API}/api/sessions/${activeSession.id}/request-reschedule`,
          { date: selectedDate },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Demande de report envoyée.");
      } else {
        await axios.patch(
          `${API}/api/sessions/${activeSession.id}/schedule`,
          { date: selectedDate },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Session planifiée avec succès.");
      }
      const { data } = await axios.get(`${API}/api/sessions/mine`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      onSaved(data);
      onClose();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Erreur serveur.");
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-[2px] flex items-center justify-center z-50 px-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-6 w-full max-w-md shadow-xl">

        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-5">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-900 text-orange-300">
              <CalendarDays className="h-4 w-4" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-slate-900">
                {activeSession.rescheduleMode ? "Demande de report" : "Planifier la session"}
              </h3>
              <p className="text-xs text-slate-500 mt-0.5">
                Code : <span className="font-mono text-indigo-600">{activeSession.code}</span>
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="text-sm text-slate-600 mb-4">
          {activeSession.rescheduleMode
            ? "Indiquez la nouvelle date souhaitée. Votre demande sera traitée manuellement."
            : "Choisissez la date à laquelle votre équipe jouera. Le code session sera activé à partir de cette date."}
        </p>

        {/* DatePicker */}
        <div className="relative w-full">
          <DatePicker
            selected={selectedDate}
            locale={fr}
            onChange={(d) => setSelectedDate(d)}
            dateFormat="dd/MM/yyyy"
            minDate={new Date()}
            placeholderText="Choisissez une date"
            dayClassName={(d) =>
              isBefore(startOfDay(d), startOfDay(new Date()))
                ? "opacity-40 text-gray-500 cursor-not-allowed"
                : "text-white"
            }
            className="w-full py-2.5 pl-10 pr-4 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-900 placeholder-slate-400 focus:ring-2 focus:ring-indigo-300 focus:outline-none shadow-sm"
            calendarClassName="light-calendar"
            popperPlacement="bottom-start"
            wrapperClassName="w-full"
          />
          <CalendarDays className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-2 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-full text-sm bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 shadow-sm transition"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={handleSave}
            disabled={!selectedDate}
            className="px-4 py-2 rounded-full text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-500 disabled:opacity-50 shadow-sm transition"
          >
            {activeSession.rescheduleMode ? "Envoyer la demande" : "Planifier"}
          </button>
        </div>
      </div>
    </div>
  );
}